import styled from '@emotion/styled';
import { BasicFlex, InputLabel, LabelUpper } from '../../utils/Common';

import { Button, Select, MenuItem, FormControl, Grid, Divider } from '@mui/material';

import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';

import useReportStore from '../../store/reports';

// report components
import SalesReport from './Components/SalesReport';

import RepairReport from './Components/RepairReport';

import ExportCsv from './Components/ExportCsv';

const Container = styled.div`
  
`;  

const HeaderSection = styled(BasicFlex)`
  margin-bottom: 3rem;
  gap: 2rem;
`;

const Tag = styled(BasicFlex)`
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primaryFaint};
  color: ${props => props.theme.colors.primary};
  font-weight: 500;
  width: fit-content;
  /* height: 4.5rem; */
  gap: .8rem;
  justify-content: center;
  padding: .8rem 1.2rem;
`

const Header = styled.h3`
  font-size: 2.6rem;
  font-weight: 400;
`;

const ActionContainer = styled(BasicFlex)`
  gap: 1rem;
  width: auto;
`; 

const ReportSelect = styled.div`

`

const Reports = () => {

  // report store - report type
  const reportType = useReportStore((state) => state.reportType);
  const setReportType = useReportStore((state) => state.setReportType);


  return (
    <Container>
      {/* <Tag><AssessmentRoundedIcon /> Reports</Tag> */}
      <HeaderSection>
        <Header>Reports & Analytics</Header>
        <ActionContainer>
          <ExportCsv />
        </ActionContainer>
      </HeaderSection>

      <ReportSelect>
        <InputLabel>Select Report Type</InputLabel>
        <FormControl sx={{bgcolor: '#fff', minWidth: "35rem"}}>
          <Select
            id="report-type"
            size="small"
            variant='outlined'
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
            IconComponent={() => null}
            sx={{
              boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
              fontSize: '1.6rem',
              '& .MuiSelect-select': {
                textAlign: 'center',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}
          >
            <MenuItem value="sales">Sales Report</MenuItem>
            <MenuItem value="repairs">Repair Report</MenuItem>
            <MenuItem value="payment">Payment Report</MenuItem>
          </Select>
        </FormControl>
      </ReportSelect>

      <Divider sx={{my: "2.5rem"}} />

      <BasicFlex justify="flex-start" gap=".3rem">
        <FilterAltRoundedIcon fontSize="small" color="icon" sx={{fontSize: "1.8rem"}} /><LabelUpper $light $size="1.3rem">Filters</LabelUpper>
      </BasicFlex>

      {reportType === "sales" ? <SalesReport /> : null}

      {reportType === "repairs" ? <RepairReport /> : null}
     
    </Container>
  )
};

export default Reports;